<script lang="ts" setup>
import type { Category } from '~/types/Category';

defineProps<{ category: Category; iconName?: string }>();
</script>

<template>
  <AppLink :to="category.uri">
    <CardBlock class="category-list-item">
      <component
        :is="`Svgo${iconName}`"
        v-if="iconName"
        :font-controlled="false"
        class="size-6 sm:size-12 text-black"
        filled
      />

      <img
        v-else-if="category.svg_url"
        :alt="category.name"
        :src="category.svg_url"
        class="size-6 sm:size-12"
      />

      <span class="text-sm">
        {{ category.name }}
      </span>
    </CardBlock>
  </AppLink>
</template>

<style lang="scss" scoped>
.category-list-item {
  display: flex;
  gap: 16px;
  align-items: center;
  height: 50px;
  padding-right: 8px;
  padding-left: 8px;
  transition: transform 0.2s;

  @include screen-sm {
    height: 74px;
    padding-right: 12px;
    padding-left: 12px;
  }

  @apply shadow-lg;

  &:hover {
    @apply shadow-md translate-y-0.5;
  }
}
</style>
